<script>
import DropDown from '../reUse/DropDown.vue';
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import { config } from '@/config'
import sl from '@/Prevodi/Dnevnik_beri-sl.json';
import en from '@/Prevodi/Dnevnik_beri-en.json';
import it from '@/Prevodi/Dnevnik_beri-it.json';
export default {
  components: {
    DropDown,
    Notification
  },
  emits: [],
  props: {
      user: String,
  },
  data() {
    return {
      prevodi: false,
      idPilota: this.user,
      podatki: [],
      sestevki: [],
      strani: 0,
      izberiStran: 1,
      izbranZapis: [],
      Letala: [],
      LetalaMotorna: [],
      searchPilot: '',
      urejanje: false,
      dVzlet: false,
      dPristanek: false,
      dLetalo: false,
      //PODATKI ZA UREJANJE
      datum: '',
      idUrejanja: '',
      odhod_cas: '',
      krajVzleta: '',
      krajPristanka: '',
      varianta: '',
      regLetala: '',
      imeVodje: '',
      pogoji: '', // dan, noc
      pristanki: 0,
      posadka: '', // SE, ME, VEČ
      ttof: '', // total time of flight
      vloga: '', // PIC, COP, DUAL, INST
      operativa: '', // dnevno, nocno, IFR
      fstd: '',
      podatkiIzbris: {},
      prihod_cas: '',
      opombe: '', // opombe
      showSkupno: false,
      text: '',
      types: '',
      ShowNoti: false,
      tiskam: false,
      posiljam: false,
      pot: config.baseUrl,
    };
  },

  computed: {
    prikazaneStrani() {
      const totalApi = Number(this.strani) || 1;
      const current = Number(this.izberiStran) || 1;
      const total = (this.podatki?.length || 0) === 10 ? Math.max(totalApi, current + 1) : totalApi;
      let start = Math.max(1, current - 2);
      let end = Math.min(total, start + 4);
      start = Math.max(1, end - 4);

      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i);
      }
      return result;
    },
    imaVecStrani() {
      return (Number(this.strani) || 1) > 1 || ((this.podatki?.length || 0) === 10 && (Number(this.izberiStran) || 1) === 1);
    },
    imaNaslednjoStran() {
      const trenutna = Number(this.izberiStran) || 1;
      const total = Number(this.strani) || 1;
      return total > trenutna || (this.podatki?.length || 0) === 10;
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.BranjePodatkov();
    this.GetLetala();
    this.GetLetalisca();
  },

  methods: {
    GetLetalisca() {
      let app = this;
      axios
          .get("./api/sifranti/letalisca/beri/")
          .then(function (response) {
            app.Letalisca = response.data;
          })
          .catch(function (napaka) {
            if (error.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (error.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = "Napaka";
            this.ShowNoti = true;
          })
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            for (let i = 0; i < response.data.letala.length; i++) {
              if (response.data.letala[i].vrsta_letala === 'Jadralno') {
                app.Letala.push(response.data.letala[i]);
              } else if (response.data.letala[i].vrsta_letala === 'Motorno') {
                app.LetalaMotorna.push(response.data.letala[i]);
              }
            }
            app.LetalaMotorna = app.LetalaMotorna.filter(letalo => letalo.vlecno === true); //dodano filtriranje za prikaz samo letal, ki so označena za vleko
          })
          .catch(function (napaka) {
            if (error.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (error.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = "Napaka";
            this.ShowNoti = true;
          })
    },
    OpenVzlet() {
      this.dVzlet = !this.dVzlet;
    },
    OpenPristanek() {
      this.dPristanek = !this.dPristanek;
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    selectVzlet(id) {
      let vzlet = this.Letalisca.letalisca.find(vl => vl.id === id);
      if (vzlet) {
        this.dVzlet = false;
        this.krajVzleta = vzlet.icao;
      }
    },
    selectPristanek(id) {
      let pristanek = this.Letalisca.letalisca.find(pr => pr.id === id);
      if (pristanek) {
        this.dPristanek = false;
        this.krajPristanka = pristanek.icao;
      }
    },
    selectLetalo(id) {
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        this.regLetala = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    BranjePodatkov() {
      let vue = this;
      let php_podatki = new URLSearchParams();
      php_podatki.append('pilot_id', this.user);
      php_podatki.append('stran', this.izberiStran);
      axios
          .post('./api/pl_beri/', php_podatki, {withCredentials: true})
          .then(function (response) {
            vue.podatki = response.data.podatki || [];
            vue.sestevki = response.data.sestevki;
            const stStrani = parseInt(response.data.st_strani, 10);
            vue.strani = Number.isFinite(stStrani) && stStrani > 0 ? stStrani : 1;

            if (vue.izberiStran > vue.strani) {
              vue.izberiStran = vue.strani;
              vue.BranjePodatkov();
            }
          })
          .catch(function () {
            if (error.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (error.response.data.sporocilo !== undefined) {
              this.text = 'Napaka pri vnosu. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri vnosu.';
            }
            this.types = "Napaka";
            this.ShowNoti = true;
          });
    },
    NastaviStran(stran) {
      const novaStran = parseInt(stran, 10);
      if (!Number.isFinite(novaStran)) return;
      const trenutna = Number(this.izberiStran) || 1;
      const totalApi = Number(this.strani) || 1;
      const maxStran = (this.podatki?.length || 0) === 10 ? Math.max(totalApi, trenutna + 1) : totalApi;
      if (novaStran < 1 || novaStran > maxStran) return;
      if (novaStran === this.izberiStran) return;

      this.izberiStran = novaStran;
      this.BranjePodatkov();
    },
    PrejsnjaStran() {
      this.NastaviStran((Number(this.izberiStran) || 1) - 1);
    },
    NaslednjaStran() {
      this.NastaviStran((Number(this.izberiStran) || 1) + 1);
    },
    UrediZapis(id) {
      this.idUrejanja = id;
      this.urejanje = true;
      this.krajVzleta = this.izbranZapis[0].odhod_kraj;
      this.krajPristanka = this.izbranZapis[0].prihod_kraj;
      this.regLetala = this.izbranZapis[0].zrakoplov_registracija;
      this.varianta = this.izbranZapis[0].zrakoplov_model;
      this.imeVodje = this.izbranZapis[0].ime_vodja_zrakoplova;

      if (this.izbranZapis[0].st_pristajanj_dan > 0) {
        this.pristanki = this.izbranZapis[0].st_pristajanj_dan;
        this.pogoji = 'dan';
      } else if (this.izbranZapis[0].st_pristajanj_noc > 0) {
        this.pristanki = this.izbranZapis[0].st_pristajanj_noc;
        this.pogoji = 'noc';
      }

      if (this.izbranZapis[0].eno_posadka_se !== null) {
        this.posadka = 'SE';
      } else if (this.izbranZapis[0].eno_posadka_me !== null) {
        this.posadka = 'ME';
      } else if (this.izbranZapis[0].posadka !== null) {
        this.posadka = 'vec';
      }

      if (this.izbranZapis[0].vloga_p_let.substring(0, 3) === 'PIC') {
        this.vloga = 'PIC';
      } else if (this.izbranZapis[0].vloga_p_let.substring(0, 2) === 'Co') {
        this.vloga = 'COP';
      } else if (this.izbranZapis[0].vloga_p_let.substring(0, 2) === 'Du') {
        this.vloga = 'DUAL';
      } else if (this.izbranZapis[0].vloga_p_let.substring(0, 4) === 'Inst') {
        this.vloga = 'INST';
      }

      this.ttof = this.izbranZapis[0].ttof;

      const operativniPogoj = this.izbranZapis[0].op_pogoji.split('-');
      if (this.operativa === '') {
        if (operativniPogoj[0] === 'dnevno') {
          this.operativa = 'DAN';
        } else if (operativniPogoj[0] === 'nocno') {
          this.operativa = 'NOC';
        } else if (operativniPogoj[0] === 'IFR') {
          this.operativa = 'IFR';
        }
      }

      this.fstd = this.izbranZapis[0].s_cas_FSTD;
      this.opombe = this.izbranZapis[0].opombe;
      this.prihod_cas = this.izbranZapis[0].prihod_cas;
      this.odhod_cas = this.izbranZapis[0].odhod_cas;
      this.datum = this.izbranZapis[0].datum;
    },
    Details(id) {
      this.izbranZapis = this.podatki.filter(zapis => zapis.id === id);
      $(this.$refs.modalKartice).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalKartice).modal('hide');
      this.urejanje = false;
      // ponastavitev podatkov
      this.idUrejanja = '';
      this.odhod_cas = '';
      this.krajVzleta = '';
      this.krajPristanka = '';
      this.varianta = '';
      this.regLetala = '';
      this.imeVodje = '';
      this.pogoji = '';
      this.pristanki = 0;
      this.posadka = '';
      this.ttof = '';
      this.vloga = '';
      this.operativa = '';
      this.fstd = '';
      this.prihod_cas = '';
      this.opombe = '';
    },
    PosodobiZapis(id) {
      let app = this;
      let data = new URLSearchParams();
      data.append('id', app.idUrejanja);
      data.append('datum', app.datum);
      data.append('odhod_cas', app.odhod_cas);
      data.append('odhod_kraj', app.krajVzleta);
      data.append('ime_vodja_zrakoplova', app.imeVodje);
      data.append('posadka', app.posadka);
      data.append('prihod_cas', app.prihod_cas);
      data.append('prihod_kraj', app.krajPristanka);
      data.append('zrakoplov_model', app.varianta);
      data.append('zrakoplov_registracija', app.regLetala);
      data.append('opombe', app.opombe);
      data.append('op_pogoji', app.operativa);
      data.append('pristanki', app.pristanki);
      data.append('s_cas_FSTD', app.fstd);
      if (app.pogoji === 'dan') {
        data.append('st_pristajanj_dan', app.pristanki);
        data.append('st_pristajanj_noc', null);
      } else {
        data.append('st_pristajanj_dan', null);
        data.append('st_pristajanj_noc', app.pristanki);
      }
      data.append('ttof', app.ttof);
      data.append('vloga_p_let', app.vloga);
      axios
          .post('./api/pl_uredi/', data, {withCredentials: true})
          .then(function (response) {
            app.text = 'Uspešno urejeno!';
            app.types = "Uspešno";
            app.ShowNoti = true;
            app.BranjePodatkov();
            app.DetailsOff();
          }).catch(function (error) {
        if (error.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (error.response.data.napaka !== undefined) {
          this.text = 'Napaka pri posodabljanju. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri posodabljanju.';
        }
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    OpenSkupno() {
      this.showSkupno = !this.showSkupno;
    },
    PotrdiIzbris(id) {
      this.podatkiIzbris = {
        id: id
      };
      this.text = 'Ali res želite pobrisati zapis?';
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiZapis() {
      // BRISANJE
      let app = this;
      let izbris = new URLSearchParams();
      izbris.append("brisi_id", this.podatkiIzbris.id);
      axios
          .post("./api/pl_brisi/", izbris)
          .then(function (response) {
            app.text = 'Uspešno izbrisano!';
            app.types = "Uspešno";
            app.ShowNoti = true;
            app.BranjePodatkov();
            app.DetailsOff();
            app.podatkiIzbris = {};
          })
          .catch(function (napaka) {
            if (error.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (error.response.data.napaka !== undefined) {
              this.text = 'Napaka pri posodabljanju. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri posodabljanju.';
            }
            this.types = "Napaka";
            this.ShowNoti = true;
          })
    },
    NatisniIzpise() {
      this.tiskam = true;
      var podatki = new URLSearchParams();
      podatki.append('motorni_podatki', JSON.stringify(this.podatki));
      axios.post('./api/pl_pdf/', podatki, {withCredentials: true}).then((response) => {
        this.tiskam = false;
        window.open(this.pot + response.data.datoteka);
      }).catch((napaka) => {
        this.tiskam = false;
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    SendToMail() {
      this.posiljam = true;
      var podatki = new URLSearchParams();
      podatki.append('motorni_podatki', JSON.stringify(this.podatki));
      axios.post('./api/pl_pdf/', podatki, {withCredentials: true}).then((response) => {
        var podatkiMail = new URLSearchParams();
        podatkiMail.append('datoteka', response.data.datoteka);
        podatkiMail.append('zadeva', 'Izpisek dnevnika pilota (motorni)');
        podatkiMail.append('osebno', true);
        axios.post('./api/log/mail/', podatkiMail, {withCredentials: true}).then((response) => {
          // alert(response.data.sporocilo);
          this.posiljam = false;
          this.text = (response.data.sporocilo);
          this.types = "Uspešno";
          this.ShowNoti = true;
        }).catch((napaka) => {
          this.posiljam = false;
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri pošiljanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri pošiljanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      }).catch((napaka) => {
        this.posiljam = false;
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      })
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
    IzpisPogojev(pogoj) {
      let [opis, cas] = pogoj.split('-');
      let [ure, minute] = cas.split(':');

      ure = ure.padStart(2, '0');
      minute = minute.padStart(2, '0');

      return `${opis}-${ure}h:${minute}min`;
    },

    IzpisCasLetenja(cas) {
      let [ure, minute] = cas.split(':');

      return `${ure}h:${minute}min`;
    }
  }
}
</script>
<template>
  <div class="col-12" v-if="prevodi">
    <div class="container">
      <div class="drop-down-icon text-black" @click.prevent="OpenSkupno()">
        <i v-show="!showSkupno" class="fas fa-chevron-right"></i>
        <i v-show="showSkupno" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" type="text" id="Skupno" @click.prevent="OpenSkupno()">{{$t('povzetek.title')}}</button>
      <transition name="fade">
        <div v-if="showSkupno" class="container row p-2">
          <div class="col-12 col-md-6 p-1" v-if="sestevki.ttof_365 !== undefined">
            <div class="container">
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.skupno30')}}</p>
                  <p class="fs-6 fw-bold">{{ sestevki.ttof_30 }} ur</p>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.skupno90')}}</p>
                  <p class="fs-6 fw-bold">{{ sestevki.ttof_90 }} ur</p>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-lg border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.skupno365')}}</p>
                  <p class="fs-6 fw-bold">{{ sestevki.ttof_365 }} ur</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 p-1" v-if="sestevki.statistika_letenja.vseh_letov !== undefined">
            <div class="container">
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.vsiO')}}</p>
                  <p class="fs-6 fw-bold">{{ sestevki.statistika_letenja.vseh_letov }}</p>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.povprecje')}}</p>
                  <p class="fs-6 fw-bold">{{ sestevki.statistika_letenja.povp_dolzina_leta }} ur</p>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('povzetek.najveckratV')}}</p>
                  <p class="fs-6 fw-bold">{{ sestevki.statistika_letenja.najveckrat_leteno }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>


  <div class="container text-white text-center" v-if="prevodi">
    <!-- IZPIS -->
    <section class="flight-section-pregled mt-2">

      <div class="section-header">
        <div class="section-icon motor">
          <i class="fas fa-book"></i>
        </div>
        <div class="d-flex col-10 justify-content-between">
          <div>
            <h2>{{ $t('table.diaryTitle') }}</h2>
          </div>
          <div class='col-4'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!podatki.length > 0 || tiskam" @click.prevent="NatisniIzpise">{{$t('buttons.natisni')}} <i class="fas fa-print" :class="{'fa-spin': tiskam}"></i></button>
          </div>
          <div class='col-3'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!podatki.length > 0 || posiljam" @click.prevent="SendToMail">{{$t('buttons.poslji')}} <i class="far fa-envelope" :class="{'fa-spin': posiljam}"></i></button>
          </div>
        </div>
      </div>

      <div class="flight-list">

        <div
            class="diary-item-pregled"
            v-for="id in podatki" :key="id.id"
            @click.prevent="Details(id.id)"
        >

          <div class="flight-date">
            <i class="fas fa-calendar"></i>
            <span>{{ id.datum }}</span>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.letalisce')}}</span>
            <strong>{{ id.odhod_kraj}}-{{id.prihod_kraj}}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.ttof')}}</span>
            <strong>{{ id.ttof }}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.vzlet')}}</span>
            <strong>{{ id.odhod_cas}}</strong>
          </div>

          <div class="flight-action">
            <i class="fas fa-chevron-right"></i>
          </div>

        </div>

        <div v-if="!podatki.length" class="empty-state">
          <i class="far fa-folder-open"></i>
          <span>Ni podatkov</span>
        </div>

      </div>

    </section>
    <!-- /IZPIS -->

    <div class="row p-2" v-if="imaVecStrani">
      <div class="col-12 d-flex justify-content-center align-items-center flex-wrap gap-2">
        <button class="btn btn-sm btn-outline-light" @click.prevent="NastaviStran(1)" :disabled="izberiStran <= 1">«</button>
        <button class="btn btn-sm btn-outline-light" @click.prevent="PrejsnjaStran" :disabled="izberiStran <= 1">Prejsnja</button>

        <button
            v-for="stran in prikazaneStrani"
            :key="'stran-'+stran"
            class="btn btn-sm"
            :class="stran === izberiStran ? 'btn-warning text-dark' : 'btn-outline-light'"
            @click.prevent="NastaviStran(stran)">
          {{ stran }}
        </button>

        <button class="btn btn-sm btn-outline-light" @click.prevent="NaslednjaStran" :disabled="!imaNaslednjoStran">Naslednja</button>
        <button class="btn btn-sm btn-outline-light" @click.prevent="NastaviStran(strani)" :disabled="izberiStran >= strani">»</button>
      </div>
    </div>
  </div>

  <!-- PILOT PODROBNO -->
  <div class="modal modal-kartica" ref="modalKartice" tabindex="-1" role="dialog" v-if="prevodi">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content list-dark border-orange" v-if="izbranZapis.length > 0">
        <div class='d-flex justify-content-end'>
          <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
            <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
          </button>
        </div>
        <div class='modal-header'>
          <h5 class="card-title"><i class="fas fa-plane-departure fa-lg"></i> Izbran zapis</h5>
        </div>
        <div class="modal-body col-12" v-if="!this.urejanje">
          <ul class='list-group list-group-flush'>
            <li class="list-group-item list-dark">{{$t('modal.datum')}}
              <span class="text-lorange">{{izbranZapis[0].datum}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.casL')}}
              <span class="text-lorange">{{ IzpisCasLetenja(izbranZapis[0].ttof) }}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.pristankiD')}}
              <span class="text-lorange">{{izbranZapis[0].st_pristajanj_dan}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.pristankiN')}}
              <span class="text-lorange">{{izbranZapis[0].st_pristajanj_noc}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.op')}}
              <span class="text-lorange">{{ IzpisPogojev(izbranZapis[0].op_pogoji) }}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.vp')}}
              <span class="text-lorange">{{ IzpisPogojev(izbranZapis[0].vloga_p_let) }}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.fstd')}}
              <span class="text-lorange">{{izbranZapis[0].s_cas_FSTD}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.odhod')}}
              <span class="text-lorange">{{izbranZapis[0].odhod_cas}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.krajO')}}
              <span class="text-lorange">{{izbranZapis[0].odhod_kraj}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.prihod')}}
              <span class="text-lorange">{{izbranZapis[0].prihod_cas}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.krajP')}}
              <span class="text-lorange">{{izbranZapis[0].prihod_kraj}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.zrakoplov')}}
              <span class="text-lorange">{{izbranZapis[0].zrakoplov_model}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.reg')}}
              <span class="text-lorange">{{izbranZapis[0].zrakoplov_registracija}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.vodjaZ')}}
              <span class="text-lorange">{{izbranZapis[0].ime_vodja_zrakoplova}}</span>
            </li>
            <li class='list-group-item list-dark'>{{$t('modal.opomba')}}
              <span class="text-lorange">{{izbranZapis[0].opombe}}</span>
            </li>
          </ul>
        </div>
        <ul class='list-group list-group-flush' v-else>
          <!---ODHOD ČAS--->
          <li class='list-group-item list-dark'>
            {{$t('labels.casO')}}
            <span class='text-lorange'>{{izbranZapis[0].odhod_cas}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Čas odhoda" id="odhod_cas" v-model="odhod_cas" required />
          </li>
          <!---ODHOD KRAJ--->
          <li class='list-group-item list-dark'>
            {{$t('modal.krajO')}}
            <span class='text-lorange'>{{izbranZapis[0].odhod_kraj}}</span>
            <div class="container">
              <label class="label-dropdown" for="namen">Izberi vzlet : <button v-if="krajVzleta !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="krajVzleta = ''">Pobriši izbiro</button></label>
              <div class="drop-down-icon text-black" @click.prevent="OpenVzlet()">
                <i v-show="!dVzlet" class="fas fa-chevron-right"></i>
                <i v-show="dVzlet" class="fas fa-chevron-down"></i>
              </div>
              <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajVzleta" @click.prevent="OpenVzlet">{{krajVzleta}}</button>
              <transition name="fade">
                <drop-down @vzlet="selectVzlet" :data="Letalisca" type="vzlet" class="drop-down-btn" v-if="dVzlet" />
              </transition>
            </div>
          </li>
          <!---ČAS PRIHODA--->
          <li class='list-group-item list-dark'>
            {{$t('labels.casP')}}
            <span class='text-lorange'>{{izbranZapis[0].prihod_cas}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Čas prihoda" id="prihod_cas" v-model="prihod_cas" required />
          </li>
          <!---KRAJ PRISTANKA--->
          <li class='list-group-item list-dark'>
            {{$t('modal.krajP')}}
            <span class='text-lorange'>{{izbranZapis[0].prihod_kraj}}</span>
            <div class="container">
              <label class="label-dropdown" for="krajPristanka"> {{$t('labels.pristanek')}} <button v-if="krajPristanka !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="krajPristanka = ''"> {{$t('buttons.brisiIzbiro')}}</button></label>
              <div class="drop-down-icon text-black" @click.prevent="OpenPristanek()">
                <i v-show="!dPristanek" class="fas fa-chevron-right"></i>
                <i v-show="dPristanek" class="fas fa-chevron-down"></i>
              </div>
              <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajPristanka" @click.prevent="OpenPristanek">{{krajPristanka}}</button>
              <transition name="fade">
                <drop-down @pristanek="selectPristanek" :data="Letalisca" type="pristanek" class="drop-down-btn" v-if="dPristanek" />
              </transition>
            </div>
          </li>
          <!-- MODEL, VARIANTA ZRAKOPLOVA-->
          <li class='list-group-item list-dark'>
            {{$t('labels.model')}}
            <span class='text-lorange'>{{izbranZapis[0].zrakoplov_model}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="varianta" v-model="varianta" required />
          </li>
          <!-- REGISTRACIJA -->
          <li class='list-group-item list-dark'>
            {{$t('labels.reg')}}
            <div class="container">
              <label class="label-dropdown" for="regLetala"> {{$t('labels.regL')}} <button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="regLetala = ''"> {{$t('buttons.brisiIzbiro')}}</button></label>
              <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
                <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
                <i v-show="dLetalo" class="fas fa-chevron-down"></i>
              </div>
              <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenLetalo">{{regLetala}}</button>
              <transition name="fade">
                <drop-down @letalo="selectLetalo" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo" />
              </transition>
            </div>
          </li>
          <!-- IME VODJE ZRAKOPLOVA-->
          <li class='list-group-item list-dark'>
            {{$t('labels.vodjaZ')}}
            <span class='text-lorange'>{{izbranZapis[0].ime_vodja_zrakoplova}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="imeVodje" v-model="imeVodje" required />
          </li>
          <!-- POSADKA -->
          <li class='list-group-item list-dark'>
            {{$t('labels.posadka')}}
            <div class="input border-0 rounded-4 p-2 fs-5">
              <div class="row">
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="posadka" inputId="posadka" name="SE" value="SE" />
                  <label class="p-1" style="color: white;" for="posadka"> SE</label>
                </div>
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="posadka" inputId="posadka" name="ME" value="ME" />
                  <label class="p-1" style="color: white;" for="posadka"> ME</label>
                </div>
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="posadka" inputId="posadka" name="vec" value="vec" />
                  <label class="p-1" style="color: white;" for="posadka"> VEČ</label>
                </div>
              </div>
            </div>
          </li>
          <!-- ŠT. PRISTANKOV in TYPE OF-->
          <li class='list-group-item list-dark'>
            {{$t('labels.pogoji')}}
            <div class="input border-0 rounded-4 p-2 fs-5">
              <div class="row">
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="pogoji" inputId="pogoji" name="danpogoj" value="dan" />
                  <label class="p-1" style="color: white;" for="pogoji">  {{$t('labels.pD')}}</label>
                </div>
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="pogoji" inputId="pogoji" name="nocpogoj" value="noc" />
                  <label class="p-1" style="color: white;" for="pogoji">  {{$t('labels.pN')}}</label>
                </div>
              </div>
            </div>
          </li>
          <!-- ŠT. PRISTANKOV -->
          <li class='list-group-item list-dark'>
            {{$t('labels.stPristankov')}}
            <span class='text-lorange'>{{pristanki}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="number" min="1" step="1" id="pristanki" v-model="pristanki" required />
          </li>
          <!--TTOF-->
          <li class='list-group-item list-dark'>
            Ttof:
            <span class='text-lorange'>{{izbranZapis[0].ttof}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="TTOF" id="ttof" v-model="ttof" required />
          </li>
          <!--OPERATIVNI POGOJI-->
          <li class='list-group-item list-dark'>
            {{$t('labels.op')}}
            <span class='text-lorange'>{{}}</span>
            <div class="input border-0 rounded-4 p-2 fs-5">
              <div class="row">
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="dan" value="DAN" />
                  <label class="p-1" style="color: white;" for="operativa">  {{$t('labels.opD')}}</label>
                </div>
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="noc" value="NOC" />
                  <label class="p-1" style="color: white;" for="operativa">  {{$t('labels.opN')}}</label>
                </div>
                <div class="col-4 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="operativa" inputId="operativa" name="ifr" value="IFR" />
                  <label class="p-1" style="color: white;" for="operativa"> IFR</label>
                </div>
              </div>
            </div>
          </li>
          <!--VLOGA PILOTA-->
          <li class='list-group-item list-dark'>
            {{$t('labels.vp')}}
            <span class='text-lorange'>{{}}</span>
            <div class="input border-0 rounded-4 p-2 fs-5">
              <div class="row">
                <div class="col-3 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="vloga" inputId="vloga" name="pic" value="PIC" />
                  <label class="p-1" style="color: white;" for="vloga"> PIC</label>
                </div>
                <div class="col-3 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="vloga" inputId="vloga" name="cop" value="COP" />
                  <label class="p-1" style="color: white;" for="vloga"> COP</label>
                </div>
                <div class="col-3 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="vloga" inputId="vloga" name="dual" value="DUAL" />
                  <label class="p-1" style="color: white;" for="vloga"> DUAL</label>
                </div>
                <div class="col-3 text-center">
                  <input class="" style="scale: 1.4;" type="radio" v-model="vloga" inputId="vloga" name="inst" value="INST" />
                  <label class="p-1" style="color: white;" for="vloga"> INST</label>
                </div>
              </div>
            </div>
          </li>
          <!-- FSTD -->
          <li class='list-group-item list-dark'>
            {{$t('labels.fstd')}}
            <span class='text-lorange'>{{izbranZapis[0].s_cas_FSTD}}</span>
            <input class="input border-0 rounded-4 p-2 fs-5" type="number" min="1" step="1" id="fstd" v-model="fstd" required />
          </li>
          <!-- OPOMBA -->
          <li class='list-group-item list-dark'>
            {{$t('labels.opomba')}}
            <span class='text-lorange'>{{izbranZapis[0].opombe}}</span>
            <textarea class="input-comment border-0 rounded-4 p-2 fs-5" type="textarea" id="opombe" v-model="opombe" rows="6" autocomplete="off"></textarea>
          </li>
        </ul>
        <div class="modal-footer col-12">
          <div class="modal-footer col-12">
            <button class="btn btn-outline-warning" v-if="!this.urejanje" @click.prevent="UrediZapis(izbranZapis[0].id)"><i class="fas fa-user-edit"></i> {{$t('buttons.urediPodatke')}} </button>
            <button class="btn btn-outline-success" v-else @click.prevent="PosodobiZapis(izbranZapis[0].id)"><i class="fas fa-sync-alt"></i> {{$t('buttons.posodobiPodatke')}} </button>&nbsp;
            <button class="btn btn-outline-danger" v-if="!this.urejanje" @click.prevent="PotrdiIzbris(izbranZapis[0].id)"><i class="fas fa-trash"></i> {{$t('buttons.brisiZapis')}} </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="izbrisiZapis" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
  <div class='col-12 p-5'></div>
</template>
<style>
.diary-item-pregled {
  display: grid;

  grid-template-columns: 1fr 1fr 1fr 1fr auto;

  align-items: center;

  gap: 20px;

  padding: 13px 15px;

  border-radius: 9px;

  cursor: pointer;

  transition:
      background .2s ease,
      transform .2s ease;
  border: 1px solid gray;
  margin-top: 0.5rem;
}
.diary-item-pregled:hover {
  background: #1e2530;
}
@media (max-width: 900px) {

  .diary-item-pregled {
    grid-template-columns: 1fr 1fr;
    gap: 2px;
    position: relative;
    padding-right: 55px;
    border-bottom: 1px solid gray;
  }
}


@media (max-width: 650px) {

  .diary-item-pregled {
    grid-template-columns: 1fr;
  }
}
</style>